import { apiClient } from './client';
import type { ApiResponse } from '@/types/api.types';

// ── Types ─────────────────────────────────────────────────────────────────────

export interface NotificationDto {
  id:            string;
  title:         string;
  message:       string;
  type:          number;
  typeName:      string;
  module:        string | null;
  referenceId:   string | null;
  referenceType: string | null;
  actionUrl:     string | null;
  isRead:        boolean;
  readAt:        string | null;
  createdAt:     string;
}

export interface UnreadCountDto {
  count: number;
}

// ── API client ────────────────────────────────────────────────────────────────

export const notificationsApi = {
  getMyNotifications: (unreadOnly = false, take = 50) =>
    apiClient
      .get<ApiResponse<NotificationDto[]>>('/notifications', {
        params: { unreadOnly, take },
      })
      .then((r) => r.data.data ?? []),

  getUnreadCount: () =>
    apiClient
      .get<ApiResponse<number>>('/notifications/unread-count')
      .then((r) => r.data.data ?? 0),

  markAsRead: (id: string) =>
    apiClient
      .put<ApiResponse<string>>(`/notifications/${id}/read`)
      .then((r) => r.data),

  markAllAsRead: () =>
    apiClient
      .put<ApiResponse<string>>('/notifications/read-all')
      .then((r) => r.data),
};
